import { useEffect } from 'react';

// Swallows the browser default for Esc while `active` (e.g. exits element-fullscreen) so an in-app overlay can consume Esc without the browser also acting on it. macOS OS-level fullscreen is handled by the OS and can't be intercepted from JS.
export const useSuppressEscapeDefault = (active: boolean) => {
  useEffect(() => {
    if (!active) return;

    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key !== 'Escape' || event.defaultPrevented) return;
      event.preventDefault();
    };

    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [active]);
};
